import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/tokens.css';
import './styles/app.css';
import './styles/hud.css';

/* Cada publicação no Cloudflare ganha também um endereço próprio e congelado
   (<hash>.<projeto>.pages.dev). Quem cair num desses é levado ao endereço oficial,
   para nunca ficar preso numa versão antiga. */
const frozen = /^[0-9a-f]{8}\.([a-z0-9-]+\.pages\.dev)$/.exec(location.hostname);
if (frozen) location.replace(`https://${frozen[1]}${location.pathname}${location.search}${location.hash}`);

/* Se o Supabase devolver o login para a raiz do site (?code=...), conclui o login na API. */
const params = new URLSearchParams(location.search);
if (!frozen && location.pathname === '/' && params.has('code')) location.replace(`/api/auth/callback${location.search}`);

const root = document.getElementById('root');
if (!root) throw new Error('Elemento #root ausente em index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
